import { Logger, NumberUtils } from "neo-common";
import { Communication, Platforms } from "neo-games";
import { GameManager } from "./GameManager";
import { GameData } from "../Channels/Common/Datas/GameData";
import { DataManager } from "./DataManager";
import { ModuleManager } from "./ModuleManager";
import { AppContext } from "../../Common/AppContext";
import { HtmlDenomContainerElement } from "../HTMLComponents/Custom/HtmlDenomContainerElement";
import { BalanceManager } from "./BalanceManager";
import { HtmlBetSelectorContainerElement } from "../HTMLComponents/Custom/HtmlBetSelectorContainerElement";
import { HtmlController } from "../HTMLComponents/HtmlController";
import { HtmlBetSelectorContainerElement2 } from "../HTMLComponents/Custom/HtmlBetSelectorContainerElement2";
import { FreeRoundBonus } from "../Channels/Common/Bonuses/FreeRoundBonus";
import { Bet } from "../GameComponents/Bet";
import { RouletteBetType } from "../CustomComponents/RouletteBetType";
import { HtmlChipSelectorContainerElement } from "../HTMLComponents/Custom/HtmlChipSelectorContainerElement";

var RouletteSpinBet = Communication.Game.RouletteSpinBet;
var BetType = Communication.Game.BetType;

export class BetManager {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    static CoinSize: number;
    static CoinCount: number;
    static Bet: number;

    static Coins: { [coinSize: number]: Array<number> };
    static TotalBets: Array<number>;
    static Chip: number;
    static Chips: Array<number>;

    static DenomContainer: HtmlDenomContainerElement;
    static CoinCountContainer: HtmlBetSelectorContainerElement;
    static BetContainer: HtmlBetSelectorContainerElement2;

    static ChipSelector: HtmlChipSelectorContainerElement;

    static minBet: boolean = false;
    static maxBet: boolean = false;

    private static lastBets: Array<Communication.Game.RouletteSpinBet>;
    private static placedBets: { [betPlaceId: string]: Bet };
    private static placedBetsHistory: Array<Array<string>>;

    //******************************************************************************************************************
    //  INIT
    //******************************************************************************************************************

    static initializeBet(): void {
        if (GameManager.rouletteResponse.initData != null) {
            if (
                GameManager.rouletteResponse.initData.betSettings != null &&
                GameManager.rouletteResponse.initData.betSettings.chips != null
            ) {
                BetManager.Chips = GameManager.rouletteResponse.initData.betSettings.chips;
                BetManager.Chip =
                    BetManager.Chips[BetManager.Chips.indexOf(GameManager.rouletteResponse.initData.lastChip)];
                BetManager.Bet = 0;

                DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());
                DataManager.updateDataElement(GameData.DataBet);
                Platforms.Platforms.bet({
                    totalBet: BetManager.Bet,
                    userAction: DataManager.getTrustedUserAction("BET_CHANGE"),
                });
            }

            BetManager.lastBets = [];
            if (
                GameManager.rouletteResponse.initData.lastBets != null &&
                GameManager.rouletteResponse.initData.lastBets.length > 0
            ) {
                BetManager.lastBets = GameManager.rouletteResponse.initData.lastBets;
            }

            if (BetManager.ChipSelector != null) {
                BetManager.ChipSelector.addValues();
            }

            BetManager.placedBets = {};
            BetManager.placedBetsHistory = [];
        }
    }

    static changeBet(decrease: boolean = false, max: boolean = false, cycle: boolean = false): void {}

    static sortNumber(a: any, b: any) {
        return a - b;
    }

    static changeDefaultDenom(): void {}

    static changeDenom(value: number, init: boolean = false): void {}

    static changeBetByValue(value: number): void {}

    static changeCoinCount(value: number): void {}

    static cycleCoinCount(): void {}

    static maxCoinCount(): void {}

    static updateBetPosition(): void {}

    static unHideValues(credit: boolean = false): void {
        for (let i = 0; i < HtmlController.HideButtons.length; i++) {
            HtmlController.HideButtons[i].unHide(credit);
        }
    }

    //******************************************************************************************************************
    //  SPIN PREPARATION
    //******************************************************************************************************************

    static createBetForSpin(): Array<Communication.Game.RouletteSpinBet> {
        let bets: Array<Communication.Game.RouletteSpinBet> = [];

        for (let key in BetManager.placedBets) {
            if (BetManager.placedBets[key] != null) {
                if (BetManager.placedBets[key].value > 0) {
                    bets.push(
                        new RouletteSpinBet(
                            BetManager.placedBets[key].type,
                            BetManager.placedBets[key].selection,
                            BetManager.placedBets[key].value,
                        ),
                    );
                }
            }
        }

        //store last bets
        BetManager.lastBets = bets;
        return bets;
    }

    //******************************************************************************************************************
    //  BET HANDLE
    //******************************************************************************************************************

    public static changeBetByIndex(betIndex: number): void {
        BetManager.Chip = BetManager.Chips[betIndex];
        BetManager.ChipSelector.selectChip(betIndex);
    }

    public static placeBet(betPlaceId: string, grouped: boolean = false, customValue: number = -1): Bet {
        let value = BetManager.Chip;

        if (customValue > -1) {
            value = customValue;
        }

        if (BetManager.placedBets[betPlaceId]) {
            BetManager.placedBets[betPlaceId].addValue(value);
        } else {
            let betTypeArray = betPlaceId.split("_");

            if (betTypeArray.length == 2) {
                let rouletteBetType = betTypeArray[0];
                let rouletteBetSelection: number = parseInt(betTypeArray[1]);

                BetManager.placedBets[betPlaceId] = new Bet(rouletteBetType, rouletteBetSelection, value);
            }
        }

        if (grouped && BetManager.placedBetsHistory.length > 0) {
            let lastBetGroup = BetManager.placedBetsHistory[BetManager.placedBetsHistory.length - 1];
            lastBetGroup.push(betPlaceId);
        } else {
            BetManager.placedBetsHistory.push([betPlaceId]);
        }

        BetManager.updateBetValue();
        return BetManager.placedBets[betPlaceId];
    }

    public static placeDoubleBet(): Array<Bet> {
        let bets: Array<Bet> = [];

        let grouped = false;
        for (let key in BetManager.placedBets) {
            if (BetManager.placedBets[key] != null) {
                bets.push(BetManager.placeBet(key, grouped, BetManager.placedBets[key].value));
                grouped = true;
            }
        }

        return bets;
    }

    public static placeLastBets(): Array<Bet> {
        let bets: Array<Bet> = [];

        if (this.lastBets != null) {
            for (let i = 0; i < BetManager.lastBets.length; i++) {
                let lastBet = BetManager.lastBets[i];
                lastBet.type = lastBet.type.charAt(0).toUpperCase() + lastBet.type.slice(1); //capitalize

                bets.push(BetManager.placeBet(lastBet.type + "_" + lastBet.selection, i != 0, lastBet.value));
            }
        }

        return bets;
    }

    public static revertLastBet(): Array<Bet> {
        let bets: Array<Bet> = [];

        if (BetManager.placedBetsHistory.length > 0) {
            let betPlaceIds = BetManager.placedBetsHistory.pop();
            for (let i = 0; i < betPlaceIds.length; i++) {
                let bet = BetManager.placedBets[betPlaceIds[i]];

                if (bet) {
                    bet.revertLastValue();
                    bets.push(bet);
                }
            }
        }

        BetManager.updateBetValue();
        return bets;
    }

    public static resetBets(): void {
        for (let key in BetManager.placedBets) {
            BetManager.placedBets[key].resetValue();
        }

        BetManager.Bet = 0;
        BetManager.placedBetsHistory = [];

        DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());
        DataManager.updateDataElement(GameData.DataBet);
        //custom for roulette
        // Platforms.Platforms.bet({totalBet: BetManager.Bet});
    }

    public static moveChipSelectorToLeft(): void {
        let chipIndex = BetManager.ChipSelector.moveSelectorToLeft();
        BetManager.Chip = BetManager.Chips[chipIndex];
    }

    public static moveChipSelectorToRight(): void {
        let chipIndex = BetManager.ChipSelector.moveSelectorToRight();
        BetManager.Chip = BetManager.Chips[chipIndex];
    }

    //******************************************************************************************************************
    //  LIMIT CHECKER
    //******************************************************************************************************************

    public static reachedMaxTableLimit(customValue: number = -1): boolean {
        let value = BetManager.Chip;
        if (customValue > -1) {
            value = customValue;
        }

        if (DataManager.MaxTableLimit != "∞") {
            if (parseFloat(NumberUtils.add(BetManager.Bet, value)) > parseFloat(DataManager.MaxTableLimit)) {
                return true;
            }
        }

        return false;
    }

    public static reachedSingleBetLimit(betPlaceId: string, customValue: number = -1): string {
        let value = BetManager.Chip;
        if (customValue > -1) {
            value = customValue;
        }

        let betType = betPlaceId.split("_")[0];
        if (BetManager.placedBets[betPlaceId]) {
            value = parseFloat(NumberUtils.add(BetManager.placedBets[betPlaceId].value, value));
            betType = BetManager.placedBets[betPlaceId].type;
        }

        if (value > BetManager.getSingleBetLimitByType(betType)) {
            return betPlaceId;
        }

        return null;
    }

    public static betRestriction(betPlaceId: string): boolean {
        if (DataManager.BetRestrictionEnabled) {
            let betTypeArray = betPlaceId.split("_");

            if (betTypeArray.length == 2) {
                let type = betTypeArray[0];

                if (
                    type == RouletteBetType.RedOrBlack ||
                    type == RouletteBetType.LowOrHigh ||
                    type == RouletteBetType.EvenOrOdd
                ) {
                    let selection = parseFloat(betTypeArray[1]);
                    let opositeSelection = selection == 0 ? 1 : 0;

                    if (
                        BetManager.placedBets[type + "_" + opositeSelection] != null &&
                        BetManager.placedBets[type + "_" + opositeSelection].value > 0
                    ) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    //racetrack bets
    public static racetrackReachedMaxTableLimit(groupCount: number): boolean {
        let value = parseFloat(NumberUtils.multiply(BetManager.Chip, groupCount));
        return BetManager.reachedMaxTableLimit(value);
    }

    public static racetrackReachedSingleBetLimit(betPlaceIds: Array<string>): Array<string> {
        let limitBets: Array<string> = [];
        for (let i = 0; i < betPlaceIds.length; i++) {
            let key = betPlaceIds[i];

            if (BetManager.placedBets[key] != null && BetManager.placedBets[key].value > 0) {
                let result = BetManager.reachedSingleBetLimit(key);

                if (result != null) {
                    limitBets.push(result);
                }
            }
        }

        return limitBets;
    }

    //double bets
    public static doubleBetReachedMaxTableLimit(): boolean {
        return BetManager.reachedMaxTableLimit(BetManager.Bet);
    }

    public static doubleBetReachedSingleBetLimit(): Array<string> {
        let limitBets: Array<string> = [];
        for (let key in BetManager.placedBets) {
            if (BetManager.placedBets[key] != null && BetManager.placedBets[key].value > 0) {
                let value = BetManager.placedBets[key].value;
                let result = BetManager.reachedSingleBetLimit(key, value);

                if (result != null) {
                    limitBets.push(result);
                }
            }
        }

        return limitBets;
    }

    //schemas
    public static schemaBetReachedMaxTableLimit(value: number): boolean {
        return BetManager.reachedMaxTableLimit(value);
    }

    //schemas
    public static schemaBetReachedSingleBetLimit(bets: Array<Bet>): Array<string> {
        let limitBets: Array<string> = [];
        for (let i = 0; i < bets.length; i++) {
            let key = bets[i].type + "_" + bets[i].selection;

            if (BetManager.placedBets[key] != null && BetManager.placedBets[key].value > 0) {
                let result = BetManager.reachedSingleBetLimit(key, bets[i].value);

                if (result != null) {
                    limitBets.push(result);
                }
            }
        }

        return limitBets;
    }

    //******************************************************************************************************************
    //  HELPER
    //******************************************************************************************************************

    private static updateBetValue(): void {
        BetManager.Bet = 0;

        for (let key in BetManager.placedBets) {
            if (BetManager.placedBets[key] != null) {
                BetManager.Bet = parseFloat(NumberUtils.add(BetManager.Bet, BetManager.placedBets[key].value));
            }
        }

        DataManager.updateGameDataFromModule(GameData.DataBet, BetManager.Bet.toString());
        DataManager.updateDataElement(GameData.DataBet);
        //custom for roulette
        // Platforms.Platforms.bet({totalBet: BetManager.Bet});
    }

    public static hasPreviousBet(): boolean {
        return BetManager.Chips.indexOf(BetManager.Chip) > 0;
    }

    public static hasNextBet(): boolean {
        return BetManager.Chips.indexOf(BetManager.Chip) < BetManager.Chips.length - 1;
    }

    public static hasPlacedBet(): boolean {
        return BetManager.placedBetsHistory.length > 0;
    }

    public static getPlacedBets(): Array<Bet> {
        let bets: Array<Bet> = [];

        for (let key in BetManager.placedBets) {
            if (BetManager.placedBets[key].value > 0) {
                bets.push(BetManager.placedBets[key]);
            }
        }

        return bets;
    }

    public static hasLastBet(): boolean {
        return BetManager.lastBets.length > 0;
    }

    public static getBetNumbersByBetType(betType: string, selection: number): Array<number> {
        switch (betType) {
            case RouletteBetType.Single:
                return [selection];
            case RouletteBetType.SplitVertical:
                return [selection, selection - 1];
            case RouletteBetType.SplitHorizontal:
                if (selection == 1) {
                    return [selection, selection - 1];
                } else if (selection == 2) {
                    return [selection, selection - 2];
                } else {
                    return [selection, selection - 3];
                }
            case RouletteBetType.Street:
                return [selection, selection + 1, selection + 2];
            case RouletteBetType.Corner:
                return [selection, selection - 1, selection - 3, selection - 4];
            case RouletteBetType.DoubleStreet:
                return [selection, selection + 1, selection + 2, selection + 3, selection + 4, selection + 5];
            case RouletteBetType.Trio:
                return [selection, 0, selection - 1];
            case RouletteBetType.FirstFour:
                return [selection, selection + 1, selection + 2, selection + 3];
            case RouletteBetType.Basket:
                return [];
            case RouletteBetType.LowOrHigh:
                if (selection == 0) {
                    return RouletteBetType.LowNumbers;
                } else {
                    return RouletteBetType.HighNumbers;
                }
            case RouletteBetType.RedOrBlack:
                if (selection == 0) {
                    return RouletteBetType.RedNumbers;
                } else {
                    return RouletteBetType.BlackNumbers;
                }
            case RouletteBetType.EvenOrOdd:
                if (selection == 0) {
                    return RouletteBetType.EvenNumbers;
                } else {
                    return RouletteBetType.OddNumbers;
                }
            case RouletteBetType.Dozen:
                return RouletteBetType.DozenNumbers[selection];
            case RouletteBetType.Column:
                return RouletteBetType.ColumnNumbers[selection];
            default:
                return null;
        }
    }

    public static getBetMultiplierByBetType(betType: string): number {
        switch (betType) {
            case RouletteBetType.Single:
                return 36;
            case RouletteBetType.SplitVertical:
            case RouletteBetType.SplitHorizontal:
                return 18;
            case RouletteBetType.Street:
                return 12;
            case RouletteBetType.Corner:
                return 9;
            case RouletteBetType.DoubleStreet:
                return 6;
            case RouletteBetType.Trio:
                return 12;
            case RouletteBetType.FirstFour:
                return 9;
            case RouletteBetType.Basket:
                return 1;
            case RouletteBetType.LowOrHigh:
            case RouletteBetType.RedOrBlack:
            case RouletteBetType.EvenOrOdd:
                return 2;
            case RouletteBetType.Dozen:
            case RouletteBetType.Column:
                return 3;
            default:
                return 1;
        }
    }

    private static getSingleBetLimitByType(type: string): number {
        let limit = DataManager.getDataById(GameData.DataSingleBetLimit + type);

        if (limit != null) {
            return parseFloat(limit);
        }

        return -1;
    }

    private static log(s: string): void {
        if (DEBUG) {
            Logger.debugGroup("BetManager", s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Managers/BetManager.ts
 **/